import * as yup from 'yup';
import { TranslateFn } from '../../library/validationRules';
import ResourcesIds from '../../resources/ResourcesIds';

/**
 * The width of `appointments.decision_note` (changelog 034), which the API also bounds the
 * request to. Declared here so the counter, the rule and its message all say one number.
 */
export const DECLINE_REASON_MAX: number = 500;

/** What the decline dialog holds while it is filled in. */
export interface DeclineRequestFormValues {
    /**
     * The note for the patient's email. Optional: a decline with nothing to say is a decline.
     * Named `reason` to match the API's field, so a server-side refusal lands on this input
     * through `useApiFormError` rather than above the form.
     */
    reason: string;
}

export const createDeclineRequestSchema = (translate: TranslateFn) => yup.object({
    reason: yup.string().defined()
        .max(DECLINE_REASON_MAX,
            translate(ResourcesIds.DECLINE_REQUEST_REASON_TOO_LONG, { max: DECLINE_REASON_MAX })),
});
